import React, { useEffect, useState } from 'react';
import './SuccsesPage.scss';

import { Footer } from '../../shared/Footer/Footer';
import { doneIcon } from '../../shared/images/icons';
import { useDispatch, useSelector } from 'react-redux';
import { resetDATA } from '../../actions/Actions';
import ToolBar from '../../shared/ToolBar/ToolBar';

export const SuccessPage = () => {
  const dispatch = useDispatch();
  const { title, subTitle, redirect } = useSelector((state) => state.mainState);

  const [mobi, setMobi] = useState(false);
  useEffect(() => {
    if (redirect === 'mobi' && !mobi) {
      setMobi(true);
    }
    return () => {
      setMobi(false);
    };
    // eslint-disable-next-line
  }, [title, subTitle, redirect]);
  const handleReset = () => {
    if (mobi) {
      return;
    }
    dispatch(resetDATA());
  };
  return (
    <div className="successPage">
      <div className="container">
        <div className="row">
          <div className="col-md-12 col-lg-12 col xs-12">
            <ToolBar />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 col-xs-12">
            <div className="successContent">{doneIcon}</div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 col-xs-12 col-lg-12">
            <div className="headerSuccess">
              {title ? title : 'Документы успешно загружены'}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 col-xs-12 col-lg-12">
            <div className="seuccessDescription">
              {subTitle
                ? subTitle
                : 'После рассмотрения обязательно сообщим о результате. Спасибо'}
              <span />
              😊
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 col-xs-12">
            <div className="submit">
              <a
                className="links"
                href={mobi ? 'https://alif.mobi/alif.mobi/gohome' : '/'}
              >
                <div className="label" onClick={handleReset}>
                  Вернуться на главную
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="successFooter">
        <Footer />
      </div>
    </div>
  );
};
